<template>
  <section :class="[$options.name, { mobile: isMobile }]">
    <div :class="[`${$options.name}__navigation`]">
      <a href="https://edrone.me/" style="margin-right: auto">
        <img src="https://d3vhsxl1pwzf0p.cloudfront.net/images/v2/logo.svg" width="120" />
      </a>
      <template v-if="!isMobile">
        <div
          style="
            margin-left: 1.25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 0.875rem;
          "
          @click="goto"
        >
          {{ redirection.text }}
        </div>
        <div style="margin: auto 1.25rem auto 2rem; border-right: 0.125rem solid #dddddd; height: 2.5rem" />
        <EdroneSelect
          :allow-empty="false"
          :options="langOptions"
          :selected-options="[selectedLangOption]"
          style="width: 9.375rem"
          unique-id="89f42523-72a7-420c-9677-54df9c9e1bcd"
          @select="onLangChange"
        />
      </template>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import EdroneSelect from "edrone-components/EdroneSelect.vue";

export default defineComponent({
  name: "AccountMenu",
  components: {
    EdroneSelect,
  },
  props: {
    redirection: {
      type: Object,
      default: () => ({
        path: "/login",
        text: "Log in",
      }),
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const translations = window._trans["lang"];

    const localLang = ref(translations);

    const langOptions = computed(() => {
      return [
        { value: "en", name: "English" },
        { value: "pl", name: "Polski" },
        { value: "pt", name: "Portuguese" },
        { value: "es", name: "Español" },
      ];
    });

    const selectedLangOption = computed(() => {
      return langOptions.value.find((option) => option.value === localLang.value);
    });

    function onLangChange(option) {
      localLang.value = option.value;
      if (window.location.search) {
        let searchParams = window.location.search;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        searchParams.includes("lang")
          ? (searchParams = searchParams.replace(/lang=../, "lang=" + option.value))
          : (searchParams = searchParams + "&lang=" + option.value);
        window.location.href = window.location.pathname + searchParams;
      } else {
        window.location.href = window.location.href + "?lang=" + option.value;
      }
    }

    function goto() {
      window.location.href = props.redirection.path + window.location.search;
    }

    return {
      goto,
      langOptions,
      selectedLangOption,
      onLangChange,
    };
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account.scss";

.AccountMenu {
  z-index: 1;
}

.AccountMenu .AccountMenu__navigation {
  .edrone-select {
    .multiselect__tags {
      border: none !important;
      background: transparent !important;
    }

    .multiselect__input {
      background: transparent !important;
    }

    .multiselect__single {
      background: transparent !important;
    }
  }
}
</style>
